// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"1cf318a1","378":"d95c53f3","388":"b0d28ffb","454":"07e241b2","522":"abef4b2a","899":"1faa3993","979":"5c39549a"}[chunkId] + ".chunk.js";
};